import React from 'react';
import { Flex } from '@components';
import { Upload, Button, message } from 'antd';
import SiderMenu from '@pages/Assembly/siderMenu';
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import './index.css';
import { getLoginUser, createUuid } from "@utils/NHCore";
import NHFetch from "../../../../utils/NHFetch";
import CommonTip from "../common";
import { mkbz } from "@pages/Assembly/siderMenu/menuObj";
import Hint from "@pages/SelfHelp/common/hint";
import NextButton from '@pages/SelfHelp/common/nextIndex'
import { NHConfirm } from "@components/common/NHModal";
const uploadUrl = "api/zhxg-yxwz/newStudent/cacheStudentPhoto"; //上传logo路径
const getPicUrl = "api/zhxg-yxwz/newStudent/getStudentPhoto";//获取图片路径

function beforeUpload(file) {

    const isJPG = file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png" || file.type === "image/jif" || file.type === "image/bmp";
    if (!isJPG) {
        message.error("上传照片格式错误!");
    }
    const isLt2M = file.size / 1024 / 1024 < 0.5;
    if (!isLt2M) {
        message.error("照片大小必须小于500KB!");
    }
    return isJPG && isLt2M;
}

export default class pagePrint extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mkbz: 'GD019',
            hjmc: '',
            loading: false,
            xsid: '',//学生id
            nextUrl: '',//左侧菜单加载完后传进来
            search: '',
            operable: true,//是否显示环节
            nonOperationalData: {},//不可操作的数据
            imageUrl: '',
            photoUUID: '',
            zt: true,//保存按钮是否显示
            tempUrl: <img style={{ width: '120px', height: '168px' }} src={getPicUrl + '?xsid=' + getLoginUser().userId + '&type=10&uuid=' + createUuid()} alt="" className="avatar" />,
        };
    }

    componentDidMount() {
        let userId = getLoginUser() ? getLoginUser().userId : undefined;

        if (userId) {
            this.setState({
                xsid: userId,
                tempUrl: <img style={{ width: '120px', height: '168px' }} src={getPicUrl + '?xsid=' + userId + '&type=10&uuid=' + createUuid()} alt="" className="avatar" />
            }, () => {
                if (this.state.tempUrl) {
                    this.setState({ zt: false })
                }
            });
        }
        this.queryQztjAndYlhj();
    }

    //查询前置条件和依赖环节
    queryQztjAndYlhj = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        if (!xsid) {
            this.setState({
                nonOperationalData: { nologin: true },
                operable: false,
            });
            return;
        }
        let zzbdhjid = this.getQueryString('pkid');
        NHFetch("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid })
            .then(res => {
                if (res && res.data) {
                    let kfsj = res.data['kfsj'];
                    let ylhj = res.data['ylhj'];
                    let qzhj = res.data['qzhj'];
                    this.setState({ nonOperationalData: res.data });
                    if (kfsj['YXSJ'] != '1') {
                        this.setState({ operable: false });
                    }

                    if (ylhj && ylhj.length > 0) {
                        this.setState({ operable: false });
                    }

                    if (qzhj && qzhj.length > 0) {
                        this.setState({ operable: false });
                    }
                }
            });
    }

    getQueryString = (name) => {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    }

    setMenuList = (menuList) => {
        let nextCount = 0;
        let bz = this.state.mkbz;
        menuList.map((elem, index) => {
            if (elem.HJDM == bz) {
                let hjmc = elem.HJMC;
                this.setState({ hjmc: hjmc })
                nextCount = index + 1;
                return;
            }
        });
        let menu = menuList[nextCount];
        if (menu) {
            let hjdm = menu.HJDM;
            if (hjdm.indexOf('GD') == 0) {
                let gdUrl = mkbz[hjdm];
                this.setState({
                    nextUrl: gdUrl,
                    search: 'pkid=' + menu.PKID,
                })
            } else if (hjdm.indexOf('ZDY') == 0) {
                let zdyUrl = "/customLink";
                this.setState({
                    nextUrl: zdyUrl,
                    search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX,
                })
            }
        } else {
            this.setState({
                nextUrl: '',
                search: '',
            })
        }
    }

    //重新加载菜单
    reloadMenu = () => {
        this.refs.siderMenu.reloadMenuList()
    }

    // 上传图片
    handleUploadChange = info => {
        if (info && info['file'] && info['file'].status === 'done') {
            let photoUUID = info['file'].response.data;
            if (photoUUID) {
                this.setState({ photoUUID: photoUUID, zt: true })
            }
        }
        this.getBase64(info.file.originFileObj, imageUrl =>
            this.setState({ imageUrl })
        );
    }

    getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    save = (photoUUID, e) => {
        NHConfirm("是否确定保存照片？", () => {
            if (photoUUID) {
                let zzbdhjid = this.getQueryString("pkid");
                let userId = getLoginUser() ? getLoginUser().userId : undefined;
                let params = { xsid: userId, zzbdhjid: zzbdhjid }
                let url = '/newStudent/saveStudentPhoto?xsid=' + userId + '&photoUUID=' + photoUUID + '&type=' + '10';
                NHFetch(url, 'POST')
                    .then(res => {
                        if (res && res.data) {
                            NHFetch('/zzbd/savePhotoData', 'POST', params)
                                .then(res => {
                                    this.reloadMenu();
                                });
                            message.success("上传成功!")
                            this.setState({ zt: false })
                        }
                    });
            } else {
                message.error('请先上传图片！')
            }
        }, "warn");
    }

    render() {
        const { xsid, imageUrl, tempUrl, photoUUID, zt } = this.state;
        return (
            <div>{this.state.operable ?
                <Flex className="w1180 mt-20" align="start">
                    <SiderMenu
                        ref={"siderMenu"}
                        setMenuList={this.setMenuList}
                        title="自助报到"
                        unShowBlzt={"0"}
                        /*      active={8}*/
                        mkbz={this.state.mkbz}
                        menuType="自助报到"
                    />
                    <Flex.Item className="page_con_r">
                        <Breadcrumb
                            noLine
                            list={[
                                { name: '首页', url: '/index' },
                                { name: '自助报到', url: '/register' },
                                { name: this.state.hjmc }
                            ]}
                        />
                        <div className="box">
                            <div style={{ textAlign: 'center' }}>
                                <div style={{cursor: 'pointer',height:'188px',width:'140px',margin:'0 auto',border:'1px solid gray',lineHeight:'180px'}}>
                                    <Upload
                                        name="photo"
                                        accept={'image/*'}
                                        showUploadList={false}
                                        action={uploadUrl + "?xsid=" + xsid}
                                        beforeUpload={beforeUpload}
                                        onChange={this.handleUploadChange}
                                    >
                                        {imageUrl ? <img style={{ width: '120px', height: '168px', cursor: 'pointer' }} src={imageUrl} alt="" className="avatar" /> : tempUrl}
                                    </Upload>
                                </div>
                                <span style={{color:'red',paddingBottom: '10px'}}>*点击上方上传照片</span>
                                <div className="text-center mt-50" style={{ marginTop: '15px' }}>
                                    {zt ? <Button type="primary" onClick={this.save.bind(this, photoUUID)} style={{ marginRight: '20px' }}>保存照片</Button> : ''}
                                    <NextButton nextUrl={this.state.nextUrl} search={this.state.search} style={{ marginLeft: '0px' }} />
                                    <style jsx="true" global="true">
                                        {`
                                            .ml-20 {
                                                margin-left: 0px; 
                                            }
                                        `}
                                    </style>
                                </div>
                            </div>
                            <Hint />
                        </div>
                    </Flex.Item>
                </Flex>
                : <CommonTip hjmc={"个人照片采集"} key={'GD019'} mkbz='GD019' nonOperationalData={this.state.nonOperationalData} />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/pages/SelfHelp/photoInformation/index.js